import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import DatePicker from 'component/utils/DatePicker'
import CompanySelect from 'component/branch/CompanySelect'

class PeriodPickerCommercialManagement extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchCommercialManagements: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      dtStart: null,
      dtEnd: null,
    }

    this.handleChangeStartDate = this.handleChangeStartDate.bind(this)
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this)
    this.handleFetchCommercialManagements =
      this.handleFetchCommercialManagements.bind(this)
  }

  handleChangeStartDate(event) {
    const { setValueToField } = this.props

    this.setState({ dtStart: event })

    const dateFormated = event.format('DD/MM/YYYY')

    setValueToField('dtStart', dateFormated)
  }

  handleChangeEndDate(event) {
    const { setValueToField } = this.props

    this.setState({ dtEnd: event })

    const dateFormated = event.format('DD/MM/YYYY')

    setValueToField('dtEnd', dateFormated)
  }

  handleFetchCommercialManagements(event) {
    event.preventDefault()

    const { fetchCommercialManagements, values } = this.props

    fetchCommercialManagements(values)
  }

  handleChangeBranch = (event) => {
    const { fields } = this.props
    fields.idBranch.input.onChange(event)
  }

  render() {
    const {
      translate,
      fields,
      auth: { user },
    } = this.props

    return (
      <form
        onSubmit={this.handleFetchCommercialManagements}
        className='commercialManagements-page container-mobile'
      >
        <div className='margin-left-double margin-right-double center-select-date'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} className='margin-bottom-small'>
              <h5 className='name gray-label'>
                {translate('commercialManagement.hint')}
              </h5>
            </Col>

            {user.locationCode === '999' && (
              <Col xs={12}>
                <Field
                  {...fields.idBranch}
                  error={translate(fields.idBranch.error)}
                  hint={translate('ruptures.idBranch')}
                  icon='glyph glyph-clock'
                >
                  <CompanySelect
                    {...fields.idBranch.input}
                    onChange={this.handleChangeBranch}
                  />
                </Field>
              </Col>
            )}

            <Col xs={12} sm={6} md={4}>
              <Field
                {...fields.dtStart}
                error={translate(fields.dtStart.error)}
                glyph='glyph glyph-calendar'
                validate
              >
                <DatePicker
                  date={this.state.dtStart}
                  onDateChange={this.handleChangeStartDate}
                  placeholder={translate('commercialManagements.from')}
                  isOutsideRange
                />
              </Field>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Field
                {...fields.dtEnd}
                error={translate(fields.dtEnd.error)}
                glyph='glyph glyph-calendar'
                validate
              >
                <DatePicker
                  date={this.state.dtEnd}
                  onDateChange={this.handleChangeEndDate}
                  placeholder={translate('commercialManagements.to')}
                  isOutsideRange
                />
              </Field>
            </Col>

            <Col xs={12} sm={6} md={3} className='margin-top-one-point-seven'>
              <button
                type='submit'
                className='button button-primary button-full'
              >
                {translate('commercialManagements.filter')}
              </button>
            </Col>
          </Col>
        </div>
      </form>
    )
  }
}

const fields = ['idBranch', 'dtStart', 'dtEnd']

export default Form({ fields })(PeriodPickerCommercialManagement)

export { PeriodPickerCommercialManagement }
